

<div>
    <img src="assets/images/404.jpg" class="w-100 h-100 fixed-top" alt="">
</div>
